var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    { staticClass: "product-rec-sidebar" },
    [
      _c("h1", { staticClass: "h6 text-center" }, [
        _vm._v(
          _vm._s(
            _vm.settings.productRecSidebarHeading ||
              "Other Product You May Like"
          )
        )
      ]),
      _vm._l(_vm.filteredProducts, function(product) {
        return _c("product-tile-widget", {
          key: "rec_sidebar_" + product.id,
          attrs: { product: product }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }